import type { IComponentController, IScope } from "angular";
import type {
    IConfigurationGroupMonitoring,
    IMonitoringNotificationSubscription,
    IPartnerUser,
    ISite,
} from "App/Modules/Models";
import type { Duration } from "moment-timezone";
import { duration } from "moment-timezone";

export default class EditNotificationsSubscriptionsComponentController implements IComponentController {
    public static $inject: string[] = ["$scope"];

    public configurationGroup: IConfigurationGroupMonitoring;
    public site: ISite;

    public subscriptions: IMonitoringNotificationSubscription[];

    public subscribersAssigned: boolean;
    public types: any[];

    public subscribers: IPartnerUser[] = [];

    public existingSubscribers: string[];

    public durations: Array<{ value: Duration; text: string }> = [
        { value: duration(1, "seconds"), text: "Gui.Common.Immediate" },
        {
            value: duration(5, "minutes"),
            text: duration(5, "minutes").humanize(),
        },
        {
            value: duration(15, "minutes"),
            text: duration(15, "minutes").humanize(),
        },
        {
            value: duration(30, "minutes"),
            text: duration(30, "minutes").humanize(),
        },
        { value: duration(1, "hours"), text: duration(1, "hours").humanize() },
    ];
    public currentDuration: { value: Duration; text: string };

    constructor(private readonly $scope: IScope) {}

    public $onInit() {
        const unsub = this.$scope.$watch(
            "$ctrl.subscriptions",
            (subscriptions: IMonitoringNotificationSubscription[]) => {
                if (!subscriptions) {
                    return;
                }

                this.types.forEach((type) => {
                    type.selected = subscriptions.some((sub) => sub.notificationType === type.type);
                });

                subscriptions.forEach((subscription) => {
                    const subscriberExists = this.subscribers.some(
                        (subscriber) => subscriber.id === subscription.partnerUser.id,
                    );

                    if (!subscriberExists) {
                        this.subscribers.push(subscription.partnerUser);
                    }
                });

                this.existingSubscribers = this.subscribers.map((x) => x.id);
                unsub();
            },
        );
    }

    public addSubscriber(user: IPartnerUser) {
        if (this.subscribers.some((subs) => subs.id === user.id)) {
            return;
        }

        this.subscribers.push(user);
        this.existingSubscribers.push(user.id);

        this.onInput();
    }

    public removeSubscriber(index: number) {
        this.subscribers.splice(index, 1);

        this.onInput();
    }

    public onInput() {
        this.subscriptions = [];
        this.selectedNotifications().forEach((type) => {
            this.subscribers.forEach((subscriber) => {
                this.subscriptions.push({
                    notificationType: type,
                    partnerUser: subscriber,
                } as IMonitoringNotificationSubscription);
            });
        });

        this.subscribersAssigned =
            !this.areNotificationsSelected() || (this.areNotificationsSelected() && this.subscribers.length > 0);
    }

    public areNotificationsSelected(): boolean {
        return this.types.some((type) => type.selected);
    }

    public selectedNotifications(): number[] {
        return this.types.filter((type) => type.selected).map((type) => type.type);
    }
}
